import { ShoppingBasket, Tractor, Leaf, Eye, Sun, HandCoins, Users, Sprout } from "lucide-react";

const CONSUMER = {
  icon: ShoppingBasket,
  label: "For Shoppers",
  items: [
    { icon: Leaf, title: "Pristine Organic Quality", body: "Discover fresh, locally grown and produced goods from farmers and producers in your community. Explore seasonal offerings, learn about individual producers, and choose quality products with confidence, knowing you're supporting the people behind them." },
    { icon: Eye, title: "100% Sourcing Transparency", body: "Go beyond the label and discover who grows, raises, or makes the products you buy. Explore detailed producer profiles, learn about farming practices and production methods, and connect directly with sellers to ask questions about the products that matter to you." },
    { icon: Sun, title: "Peak-Season Nutrition", body: "Experience the variety and flavour of locally available products throughout the changing seasons. From spring harvests to autumn favourites, Source2Table helps you discover what's in season, explore new offerings, and enjoy the benefits of shopping closer to home." },
  ],
};

const FARMER = {
  icon: Tractor,
  label: "For Farmers",
  items: [
    { icon: HandCoins, title: "Fair Direct Pricing", body: "Take control of your pricing and sell your products at rates that reflect their true value. Source2Table gives you the freedom to set your own prices, communicate directly with buyers, and build profitable relationships within your local community." },
    { icon: Users, title: "Guaranteed Local Demand", body: "Put your products in front of nearby consumers who are actively searching for locally grown, raised, and produced goods. Source2Table helps increase your visibility, attract new customers, and turn local interest into lasting customer relationships." },
    { icon: Sprout, title: "Zero Middleman Margins", body: "Keep more of what you earn by connecting directly with customers instead of relying on traditional distributors or resellers. Source2Table helps shorten the supply chain, giving producers greater control over their sales while keeping more revenue in their own businesses." },
  ],
};

const AudienceColumn = ({ data, accent, testid }) => (
  <div
    data-testid={testid}
    className="rounded-3xl bg-white p-8 md:p-10 border border-[#D8E0D5] shadow-sm"
  >
    <span
      className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-sans font-bold"
      style={{ backgroundColor: `${accent}1A`, color: accent }}
    >
      <data.icon size={18} /> {data.label}
    </span>
    <div className="mt-8 space-y-7">
      {data.items.map((it) => (
        <div key={it.title} className="flex gap-4">
          <span
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl"
            style={{ backgroundColor: `${accent}1A`, color: accent }}
          >
            <it.icon size={20} />
          </span>
          <div>
            <h4 className="font-sans font-extrabold text-lg text-[#1C241B]">{it.title}</h4>
            <p className="mt-1 font-sans text-sm sm:text-base text-[#5A6757] leading-relaxed">
              {it.body}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const Features = () => {
  return (
    <section
      id="benefits"
      data-testid="features-section"
      className="bg-[#F0F4EE] py-20 md:py-32 px-4 sm:px-6 lg:px-12"
    >
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl">
          <span className="text-xs sm:text-sm font-sans uppercase tracking-[0.2em] font-bold text-[#4A6B41]">
            Benefits
          </span>
          <h2 className="mt-3 font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1C241B] tracking-tight">
            Built equally for shoppers and farmers
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <AudienceColumn
            data={CONSUMER}
            accent="#4A6B41"
            testid="features-consumer-column"
          />
          <AudienceColumn
            data={FARMER}
            accent="#C86D51"
            testid="features-farmer-column"
          />
        </div>
      </div>
    </section>
  );
};
